export default __webpack_public_path__ + "static/season-sponsors-535897f3d15e0d75414dfb9dbce24773.png";